"use strict";

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMemoizedFlags = exports.flattenFlags = exports.CustoMergeFlagEnum = exports.CustomizableLabels = void 0;
var CustomizableLabels;

(function (CustomizableLabels) {
  CustomizableLabels[CustomizableLabels["packageDefaultValue"] = 1] = "packageDefaultValue";
})(CustomizableLabels = exports.CustomizableLabels || (exports.CustomizableLabels = {}));

var CustoMergeFlagEnum;

(function (CustoMergeFlagEnum) {
  CustoMergeFlagEnum[CustoMergeFlagEnum["linking"] = 1] = "linking";
  CustoMergeFlagEnum[CustoMergeFlagEnum["avoidWithPackageDefaultValue"] = 2] = "avoidWithPackageDefaultValue";
  CustoMergeFlagEnum[CustoMergeFlagEnum["avoidWithNonPackageValue"] = 3] = "avoidWithNonPackageValue";
  CustoMergeFlagEnum[CustoMergeFlagEnum["avoidLinking"] = 4] = "avoidLinking";
})(CustoMergeFlagEnum = exports.CustoMergeFlagEnum || (exports.CustoMergeFlagEnum = {}));

exports.flattenFlags = function (deepFlags) {
  var e_1, _a, e_2, _b;

  var flags = new Set();
  if (!deepFlags) return flags;

  try {
    for (var deepFlags_1 = __values(deepFlags), deepFlags_1_1 = deepFlags_1.next(); !deepFlags_1_1.done; deepFlags_1_1 = deepFlags_1.next()) {
      var each = deepFlags_1_1.value;

      if (!Array.isArray(each) && !(each instanceof Set)) {
        if (typeof each !== "number" && typeof each !== "string") continue;
        flags.add(each);
        continue;
      }

      var setOfFlags = exports.flattenFlags(each);

      try {
        for (var setOfFlags_1 = (e_2 = void 0, __values(setOfFlags)), setOfFlags_1_1 = setOfFlags_1.next(); !setOfFlags_1_1.done; setOfFlags_1_1 = setOfFlags_1.next()) {
          var item = setOfFlags_1_1.value;
          flags.add(item);
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (setOfFlags_1_1 && !setOfFlags_1_1.done && (_b = setOfFlags_1.return)) _b.call(setOfFlags_1);
        } finally {
          if (e_2) throw e_2.error;
        }
      }
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (deepFlags_1_1 && !deepFlags_1_1.done && (_a = deepFlags_1.return)) _a.call(deepFlags_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  return flags;
};

var memoizedFlags = {};

exports.getMemoizedFlags = function (flags) {
  var flagsSet = new Set(flags);

  var keys = __spread(flagsSet).sort().join("_(R'7jY_");

  var memoizedSet = memoizedFlags[keys];
  if (memoizedSet) return memoizedSet;
  memoizedFlags[keys] = flagsSet;
  return flagsSet;
};